import { defineStore } from 'pinia';
import { getUserInfo } from '../api/user.js'

export default defineStore('userStore', {
	state: () => {
		return {
			userInfo: {},
		}
	},
	actions: {
		setUserInfo(userInfo) {
			this.userInfo = userInfo
		},
		clear() {
			this.userInfo = {};
		},
		loadUser() {
			return new Promise((resolve, reject) => {
				getUserInfo().then((userInfo) => {
					this.setUserInfo(userInfo);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		}
	}
});
